module.exports = __webpack_public_path__ + "static/img/operateMonth.eaf8cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateMonth.png
// module id = MPHe
// module chunks = 1